import { HideOptionalProps } from './typings'

export function useHideOptional(props: HideOptionalProps) {
  const {
    hideOptional,
    fieldSetting: { required, enabled } = { required: false, enabled: true },
  } = props

  return (enabled && !hideOptional) || required
}
